import { useEffect, useRef } from 'react';
import { useBooking } from '../context/BookingContext';
import { metaTrack } from '../utils/metaPixel';

const SRC_KEY = 'meta_tarangi_src';
const TARANGI_UTM_SOURCE = 'tarangiramganga';

// True only for visitors who arrived from the Tarangi website link.
// Remembered for the tab session so later steps (and payment return) still count.
const isTarangiSource = () => {
  try {
    const utm = new URLSearchParams(window.location.search).get('utm_source');
    if (utm === TARANGI_UTM_SOURCE) {
      sessionStorage.setItem(SRC_KEY, '1');
    } else if (utm) {
      sessionStorage.removeItem(SRC_KEY); // explicit different source -> not Tarangi traffic
    }
    return sessionStorage.getItem(SRC_KEY) === '1';
  } catch (e) {
    return false;
  }
};

const MetaPixelTracker = ({ currentPage }) => {
  const { state } = useBooking();
  const hotelId = state?.searchState?.hotelId;
  const lastFired = useRef('');

  useEffect(() => {
    if (!hotelId) return;
    if (!isTarangiSource()) return;
    const key = `${hotelId}|${currentPage}`;
    if (lastFired.current === key) return;
    lastFired.current = key;
    metaTrack(hotelId, 'PageView'); // still only fires for hotels in META_PIXELS (28)
  }, [hotelId, currentPage]);

  return null;
};

export default MetaPixelTracker;